/*eslint-disable no-loop-func */
import $ from 'jquery';
import _ from 'lodash';
import assign from "object-assign";
import * as Misc from "./../misc";
import ActionTypes from "../actionTypes";
import BaseStore from "./baseStore";
import Config from '../config';
import { QuotePricing, OldQuotePricing } from 'shared_components';

const serverConfig = document.kvConfig;

/***
 *
 * @type {object}
 * @private
 * @class Stones collection
 * @property {Array<Object>} Fabricators
 * @property {Array<Object>} FilteredGroup
 * @property {Array<Object>} Stones
 * @property {Array<Object>} mainMenu
 */
let _stones = null;
let _mainMenu = null;
let _fabricatorQuotePricing = {};
let _unsavedChanges = false;
/***
 *
 * @type {Object}
 * @private
 * @class Quote Data
 * @property {Array<Object>} documents
 * @property {Array<Object>} fabricators - List of fabricators
 * @property {Array<Object>} features - Array of all feature definition for current fabricator
 * @property {Array<Object>} filterGroups
 * @property {Array<Object>} notes
 * @property {Array<Object>} overlays
 * @property {Array<Object>} ratings - Fabricator ratings
 * @property {int} noPriceFeatureDefinitionId - The ID of feature definition that has no price
 * @property {int} noPriceStoneId - The ID of the stone that has no Price
 */
let _newQuoteData = null;

let _stonesLoaded = false;
let _featuresLoaded = false;
let _groupedFeatures = null;
let _groupedFeaturesDescriptions = {};


const featureGroupNameToIcon = {
  '10 year sealer': 'sealer.svg',
    'cabinet': 'cabinets.svg',
    'top mount sink cutout': 'topmount-sink-cutout.svg',
    'under mount sink cutout': 'undermount-sink-cutout.svg',
    'counter top removal': 'countertop-removal.svg',
    'cooktop cutout': 'range-top-cutout.svg',
    'cutout': 'cutouts.svg',
    'faucet': 'faucets.svg',
    'floor': 'flooring.svg',
    'range-hood-x': 'range-hood.svg',
    'range-hood-z': 'range-hood.svg',
    'refridgerator': 'refrigerator.svg',
    'removal': 'countertop-removal.svg',
    'room(s) installed': 'room.svg',
    'sink type': 'sinks.svg',
    'stove type': 'range.svg',
    'vanity door style': 'vanity-door-style.svg',
    'vanity color': 'vanity-color.svg',
    'bathtubs': 'bathtubs.svg',
    'tub & shower fixtures': 'fixtures.svg',
    'shower bases': 'shower-base.svg',
    'shower door type': 'shower-door-style-v1.svg', //shower-door-style-v2.svg
    'lighting': 'lighting.svg'
};

const featureGroupNameCorrections = {
  'cabinets': 'Cabinet',
  'range-hood-x': 'Range-Hood',
  'range-hood-z': 'Range-Hood'
}


let StonesStore = assign({}, BaseStore, {
  FILTER_GROUPS: {
    MATERIAL: 'Stone Material',
    COLOR: 'Stone Color'
  },
  /**
   *
   * @returns {boolean}
   */
  stonesLoaded: function () {
    return _stonesLoaded;
  },

  /**
   *
   * @returns {boolean}
   */
  featuresLoaded: function () {
    return _featuresLoaded;
  },

  noPriceStoneId() {
    return _newQuoteData.noPriceStoneId;
  },

  urlStoneId: null,
  urlFeatureIDs: null,
  urlParsed: false,
  userInfo: null,
  getStoneAndFeatureIDsFromUrl: function () {
    if (this.urlParsed) {
      return {stoneId: this.urlStoneId, featureIDs: this.urlFeatureIDs};
    }

    const ar = window.location.href.split('?');

    let stoneId = null;
    let featureIDs = null;
    if (ar.length > 1) {
      this.userInfo = {
        email: '',
        fullName: '',
        zip: '',
        phone: ''
      };
      _.forEach(ar[1].split('&'), (p) => {
        let pair = p.split('=');
        if (pair.length === 2) {
          const idx = pair[1].indexOf('#');
          if (idx !== -1) {
            pair[1] = pair[1].substring(0, idx);
          }

          switch (pair[0].toLowerCase()) {
            case 'sid':
              stoneId = +pair[1];
              break;
            case 'fids':
              featureIDs = [].concat(pair[1].split('.').map(function (value) {
                return +value;
              }));
              break;
            case 'email':
              this.userInfo.email = pair[1];
              break;
            case 'fullname':
              this.userInfo.fullName = pair[1];
              break;
            case 'zip':
              this.userInfo.zip = pair[1];
              break;
            case 'phone':
              this.userInfo.phone = pair[1];
              break;
          }
        }
      });
    }

    this.urlParsed = true;
    this.urlStoneId = stoneId;
    this.urlFeatureIDs = featureIDs;
    return {stoneId, featureIDs};
  },

  noPriceFeatureDefinitionId() {
    return _newQuoteData.noPriceFeatureDefinitionId;
  },

  /**
   *
   * @param groupName {String}
   * @param quote
   * @returns {*}
   */
  featuresByGroupName: function (groupName, quote) {
    if(_groupedFeatures) {
      return _.filter(_groupedFeatures[groupName], feature => {
        return !Misc.toBoolean(feature.hideFromKirchenVisualizer) && this.isFeatureVisible(feature, quote);
      });
    } else {
      return [];
    }
  },

  featuresByFabricatorAndGroupName: function(groupName, quote) {
    const groupedFeatures = _.filter(_groupedFeatures[groupName], feature => {
      return !Misc.toBoolean(feature.hideFromKirchenVisualizer) && this.isFeatureVisible(feature, quote);
    });
    const fabricator = _newQuoteData.fabricators[0];
    _.each(groupedFeatures, gf => {
      let fabFeature = _.filter(fabricator.features, feature => {
        return feature.featureId === gf.id;
      });
      if(fabFeature.length > 0) {
        fabFeature = fabFeature[0];
      }
      //console.log('fabFeature', fabFeature, fabricator.features, gf);
      if(fabFeature.unit && fabFeature.unit.length > 0)
        gf.unit = fabFeature.unit;
      if(fabFeature.description && fabFeature.description.length > 0)
        gf.description = fabFeature.description;
    });
    return groupedFeatures;
  },

  /**
   *
   * @param groupName {string}
   */
  mainFeatureFromGroup: function (groupName) {
    return _.first(_groupedFeatures[groupName]);
  },

  /***
   *
   * @param groupName
   * @returns {*}
   */
  featureGroupNameDescription: function (groupName) {
    return _groupedFeaturesDescriptions[groupName];
  },

  /**
   * Will return the supported stones
   * @returns {Array}
   */
  supportedStones: function () {
    if (!_stones) {
      return [];
    }

    return _stones.Stones;
  },

  /**
   * returns a Stone object by its ID
   * @param stoneId {int}
   */
  stoneById: function (stoneId) {
    return _.find(_stones.Stones, function (stone) {
      return stone.Id === stoneId;
    });
  },

  /**
   * return a Feature object by its ID
   * @param featureId {int}
   */
  featureById: function (featureId) {
    return _.find(_newQuoteData.features, function (f) {
      return f.id === featureId;
    });
  },

  features: function () {
    return _newQuoteData ? _newQuoteData.features : [];
  },

  fabricatorFeatures: function() {
    return _newQuoteData ? _newQuoteData.fabricators[0].features : [];
  },

  /**
   * Gets a fabricator feature
   * @param featureId
   * @returns {*}
   */
  fabricatorFeatureById: function (featureId) {
    return _.find(_newQuoteData.fabricators[0].features, {featureId: featureId});
  },

  /**
   * Gets fabricator rating information
   * @param fabricatorId
   */
  fabricatorRating: function (fabricatorId) {
    let fabricatorRatings = _.find(_newQuoteData.ratings, {fabricatorId: fabricatorId});
    if (!fabricatorRatings) {
      return 0;
    }

    let ratingSum = 0.0;
    _.each(fabricatorRatings.ratings, function (r) {
      ratingSum += r.value;
    });

    return ratingSum / _.size(fabricatorRatings.ratings);
  },

  /**
   *
   * @param quote
   * @param filterCB {func(quote, groupName, firstFeatureFromGroup)}
   * @returns {Array}
   */
  dbFeatures: function (quote, filterCB) {
    return _.filter(_.keys(_groupedFeatures), groupName => {
      const fab = _newQuoteData.fabricators[0];
      let getEnabled = (features) => {
        return _.filter(features, feature => {
          let fabFeat = _.find(fab.features, function (f) {
            return f.featureId === feature.id;
          });
          if(fabFeat && fabFeat.enabled) {
            return true;
          }
        })
      }
      const feature = _.head(getEnabled(_groupedFeatures[groupName]));
      const b = feature && this.isFeatureVisible(feature, quote);
      if (b && filterCB) {
        return filterCB(quote, groupName, _groupedFeatures[groupName][0]);
      }
      return b;
    });
  },

/**
   * Returns img url
   */
  getFeatureGroupIconURL(featureGroupName, enabled) {

    if(typeof enabled === 'undefined') enabled = true;
    const name = ((featureGroupName || '')).toLowerCase();
    const container = (enabled ? 'enabled' : 'disabled');

    const imgbaseUrl = Config.kioskStandAlone ? "./images" : ((location.port === '9007') ? "/images" : "/content/Views/QuickQuote-v3/images");

    if (name in featureGroupNameToIcon) {
      return `${imgbaseUrl}/pj-scope-icons/${container}/${featureGroupNameToIcon[name]}`;
    }

    const fileName = (name || '').toLowerCase().replace(/\s/g, '-') + '.svg';
    //console.warn(`No image available for ${featureGroupName}`);
    return `${imgbaseUrl}/pj-scope-icons/${container}/${fileName}`;
  },

  /**
   * Returns the main features which are primarily the first feature from a list with the same name
   */
  headFeatures: function () {
    return _.filter(_.values(_groupedFeatures), function (group) {
      return group.length === 1;
    }).map(function (group) {
      return _.head(group);
    });
  },

  /**
   * Checks whether a feature is visible
   * @param feature {Object}
   * @param quote
   * @returns {boolean}
   */
  isFeatureVisible: function (feature, quote) {
    const fab = _newQuoteData.fabricators[0];
    const feat = _.find(fab.features, function (f) {
      return f.featureId === feature.id;
    });
    if(!feat.enabled) {
      return false;
    }
    if (serverConfig.type !== 'Fabricator') {
      return true;
    }

    if (feat.displayLogic === null || !feat.displayLogic.enabled) {
      return true;
    }

    let visible = feat.displayLogic.action === "show";
    for (let i = 0; i < feat.displayLogic.rules.length; i++) {
      const rule = feat.displayLogic.rules[i];
      const entityId = rule.entityId;
      let entityVal = 0;
      if (entityId === -1) {
        entityVal = quote.material;
      } else {
        const fabFeat = _.find(fab.features, myfeat => myfeat.id === entityId);
        entityVal = quote.features[fabFeat.featureId];
      }

      if (!entityVal) {
        entityVal = 0;
      }
      let result = true;
      switch (rule.comparison) {
        case "<":
          result = parseInt(entityVal) < parseInt(rule.value);
          break;
        case "<=":
          result = parseInt(entityVal) <= parseInt(rule.value);
          break;
        case "=":
          result = parseInt(entityVal) === parseInt(rule.value);
          break;
        case ">":
          result = parseInt(entityVal) > parseInt(rule.value);
          break;
        case ">=":
          result = parseInt(entityVal) >= parseInt(rule.value);
          break;
      }
      if (!result) {
        visible = !visible;
        return visible;
      }
    }
    return visible;
  },

  fabricator: function () {
    return _stones ? _.first(_stones.Fabricators) : null;
  },

  getFabricatorsQuotePricing: (fabricatorId) => {
    return _fabricatorQuotePricing[fabricatorId];
  },

  getFilterGroups: () => {
    let filterGroups = {};
    if(_stones.FilterGroups) {
      for(var i = 0; i < _stones.FilterGroups.length; i++) {
        filterGroups[_stones.FilterGroups[i].Name] = _stones.FilterGroups[i];
      }
    }
    return filterGroups;
  },

  getMainMenu: () => {
    return _mainMenu;
  },

  setUnsavedChanges: (value = true) => {
    _unsavedChanges = value;
  },
  getUnsavedChanges: () => {
    return _unsavedChanges;
  },
  getFeatureGroupMeta: (featureGroupName) => {
    if(_newQuoteData && _newQuoteData.featureGroupMetas) {
      return _.find(_newQuoteData.featureGroupMetas, fgm => fgm.featureGroup == featureGroupName);
    }
    return null;
  }
});

function __groupFeatures() {
  _groupedFeatures = {};
  _.each(_newQuoteData.features, function (f) {
    if (f.id !== _newQuoteData.noPriceFeatureDefinitionId) {
      if(_newQuoteData.fabricators.length === 1) {
        const fabFeat = _.find(_newQuoteData.fabricators[0].features, ff => ff.featureId === f.id);
        if(fabFeat && fabFeat.name && fabFeat.name.length > 0) {
          f.name = fabFeat.name;
        }
      }
      const nameParts = f.name.split(' - ');
      let groupName = nameParts[0];
      let compGroupName = _.trim(groupName.toLowerCase());
      for(var name in featureGroupNameCorrections) {
        if(compGroupName == name) {
          groupName = featureGroupNameCorrections[name];
        }
      }
      f.displayName = _.tail(nameParts).join(' - ');
      if (f.displayName === '') {
        f.displayName = f.name;
      }

      if (!_groupedFeatures[groupName]) {
        _groupedFeatures[groupName] = [];
        _groupedFeaturesDescriptions[groupName] = f.displayName;
      }

      if(_.findIndex(_groupedFeatures[groupName], gf => _.trim(gf.name).toLowerCase() == _.trim(f.name).toLowerCase()) === -1)
        _groupedFeatures[groupName].push(f);
    }
  });
}

function __performPostStonesLoad() {
  const global = document.kvConfig;
  const stoneData = _stones.Stones;
  const fabData = _stones.Fabricators;
  _.each(stoneData, function (sd) {
    _.each(sd.StoneSupplierStones, function (sss) {
      sss.StoneSupplier.Fabricators = [];
      _.each(sss.StoneSupplier.FabricatorIds, function (id) {
        const fab = _.find(fabData, function (el) {
          return (el.Id === id);
        });
        sss.StoneSupplier.Fabricators.push(fab);
        /*sss.PricePlus = parseFloat(sss.PricePlus) * (1 + parseFloat(fab.Margin));
         if (sss.PricePlus === 0) {
         sss.PricePlus = parseFloat(sss.Price) * (1 + parseFloat(fab.Margin));
         }*/
      });
    });
    if (global.type === "Fabricator") {
      const _sss = sd.StoneSupplierStones[0];
      if (_sss.CustomStoneName && $.trim(_sss.CustomStoneName).length > 0) {
        sd.Name = _sss.CustomStoneName;
      }
    }
  });
}

$(document).on(ActionTypes.SERVER_DATA_LOADING, function (e, data) {
  _stonesLoaded = false;
  _featuresLoaded = false;
  $(document).trigger(ActionTypes.QUOTE_DATA_CHANGED, {});
});


$(document).on(ActionTypes.SERVER_DATA_LOADED, function (e, data) {
  _stonesLoaded = true;
  _featuresLoaded = true;
  _newQuoteData = data.newQuoteData;
  _stones = data.stonesData;
  _mainMenu = data.mainMenu;
  _fabricatorQuotePricing = {};
  _.each(_stones.Fabricators, (fab) => {
    if(fab.PricingPresets && fab.PricingPresets.length > 0) {
      _fabricatorQuotePricing[fab.Id] = QuotePricing(fab.PricingPresets);
    }
  });
  __performPostStonesLoad();
  __groupFeatures();
  _unsavedChanges = false;
  $(document).trigger(ActionTypes.SERVER_DATA_READY, {jobData: data.jobData, newQuoteData: data.newQuoteData});
});

module.exports = StonesStore;





// WEBPACK FOOTER //
// ./src/stores/stonesStore.js